<script>
import axios from '@/utils/axios';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ReminderForm from '@/components/common/reminder-form.vue';

export default {
  components: {
    ReminderForm
  }, 
  props: ['stages'], 
  inject: ['setLoading'],  
  data() {
    return {
      is_reminder: false,
      editor: ClassicEditor,
      errors: {}, 
      id: '',
      lead_id: '',
      lead_stage: '',
      description: '',
      doc_name: '',        
      document: null,      
      noteCreated: false,
      createdNoteId: null,
      isSubmitting: false
    };
  },
  methods: {
    addNote(lead) {
      this.lead_id = lead.id;
      // this.lead_stage = this.stages.find(stage => stage.id === lead.lead_stage_id);
      this.noteCreated = false;
      this.createdNoteId = null;
    },

    editNote(lead, note) {
      this.id = note.id;
      this.description = note.description;
      this.lead_id = lead.id;
      this.noteCreated = true;
      this.createdNoteId = note.id;
    },

    async submitForm() {
      if (this.isSubmitting) return;

      this.errors = {};
      this.isSubmitting = true;
      this.setLoading(true);
  
      try {
        if (!this.noteCreated) {
          let noteResponse;
          
          if (this.id) {
            // UPDATE - simple JSON (document upload nahi)
            noteResponse = await axios.put(`leads/${this.lead_id}/comments/update`, {
              id: this.id,
              description: this.description  
            });
            this.noteCreated = true;
            this.createdNoteId = this.id;

          } else {
            // CREATE - FormData use karo (document ke liye)
            const formData = new FormData();
            // formData.append('lead_stage_id', this.lead_stage?.id ?? '');
            formData.append('description', this.description);
            if (this.doc_name) formData.append('name', this.doc_name);
            if (this.document) formData.append('document', this.document);

            noteResponse = await axios.post(
              `leads/${this.lead_id}/comments/create`, 
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            this.noteCreated = true;
            this.createdNoteId = noteResponse.data.id || noteResponse.data.note?.id;
          }

          this.$swalToast('Note saved successfully!');
        }

        if (this.is_reminder) {
          const reminderSuccess = await this.$refs.reminderForm.submitReminder();
          if (reminderSuccess) {
            this.$swalToast('Reminder created successfully!');
            this.$emit('updated'); 
            this.$closeModal('notes_modal');
            this.resetForm();
          }
        } else {
          this.$emit('updated'); 
          this.$closeModal('notes_modal');
          this.resetForm();
        }
        
      } catch(error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message || 'An error occurred', 'error'); 
        }
      } finally {
        this.isSubmitting = false;
        this.setLoading(false);
      } 
    },

    handleReminderCreated(reminderData) {},
    handleReminderError(error) {},

    async deleteNote() {
      this.errors = {};
      this.setLoading(true); 
      try {
        const response = await axios.delete(`leads/${this.lead_id}/comments/${this.id}/delete`);
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('note_delete_modal');
      } catch(error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error'); 
        }
      } finally {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.id = null;
      this.description = '';
      this.doc_name = '';       
      this.document = null;     
      this.errors = {};
      this.is_reminder = false;
      this.noteCreated = false;
      this.createdNoteId = null;
      this.isSubmitting = false;
      if (this.$refs.reminderForm) {
        this.$refs.reminderForm.resetForm();
      }
      // File input manually reset karo
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    }
  }
};
</script>

<template>
  <!-- Add Note -->
  <div class="modal fade" id="notes_modal">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Add Notes</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            
            <div v-if="noteCreated" class="alert alert-success alert-dismissible mb-3">
              <i class="ti ti-checks me-2"></i>
              <strong>Note saved successfully!</strong> 
              <p v-if="is_reminder">Please complete the reminder details below.</p>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="mb-3 summer-description-box notes-summernote">
                    
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <label class="form-label mb-0">Comment</label>
                    <!-- <vue-select :options="stages" label="name" v-model="lead_stage" /> -->
                  </div>

                  <ckeditor :editor="editor" v-model="description" :disabled="noteCreated"></ckeditor>
                  <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
                  <small>Maximum 255 Characters</small>
                </div>

                <!-- NAYA: Document Name -->
                <div class="mb-3" v-if="!noteCreated">
                  <label class="form-label">Document Name</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    v-model="doc_name" 
                    placeholder="Enter document name"
                  />
                  <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
                </div>

                <!-- NAYA: File Upload -->
                <div class="mb-3" v-if="!noteCreated">
                  <label class="form-label">Attach Document</label>
                  <input 
                    type="file" 
                    class="form-control" 
                    ref="fileInput"
                    @change="e => document = e.target.files[0]"
                    accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                  />
                  <div v-if="document" class="mt-1 small text-success">
                    <i class="ti ti-paperclip me-1"></i>{{ document.name }}
                  </div>
                  <div v-if="errors.document" class="text-danger small mt-1">{{ errors.document[0] }}</div>
                </div>

              </div>
            </div>

            <div class="form-check form-check-inline form-checkbox-success mb-2">
              <input type="checkbox" class="form-check-input me-2" name="is_reminder" id="is_reminder" v-model="is_reminder" :disabled="noteCreated && !is_reminder">
              <label class="form-check-label" for="is_reminder">Create Reminder?</label>
            </div>
            
            <div v-if="is_reminder">
              <hr>
              <h5>Reminder Details</h5>
              <ReminderForm ref="reminderForm" :lead-id="lead_id" @reminder-created="handleReminderCreated" @reminder-error="handleReminderError"/>
            </div>
          </div>
          
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
              <span v-if="isSubmitting">
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                Submitting...
              </span>
              <span v-else-if="noteCreated && is_reminder">
                Create Reminder
              </span>
              <span v-else>
                Submit
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Note -->

  <!-- Delete Modal -->
  <div class="modal fade" id="note_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete all the marked items, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteNote">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>